import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { INavLink, mergeStyleSets, IconButton, Icon } from '@fluentui/react';

interface INavbarLeftComponentProps {
    menuItems: INavLink[];
};

const NavbarLeftComponent = (props: INavbarLeftComponentProps) => {
    const [expanded, setExpanded] = useState<boolean>(false);
    const navigate = useNavigate();
    const location = useLocation();

    const classes = mergeStyleSets({
        sidebar: {
            height: '100vh',
            backgroundColor: 'var(--color-primario)',
            display: 'flex',
            flexDirection: 'column',
            width: expanded ? 200 : 48,
            transition: 'width 0.2s ease',
            overflow: 'hidden',
            flexShrink: 0,
        },
        toggleBtn: {
            color: 'white',
            backgroundColor: 'transparent',
            border: 'none',
            height: 48,
            width: 48,
            flexShrink: 0,
            selectors: {
                ':hover': { backgroundColor: 'rgba(255,255,255,0.15)' },
                i: { color: 'white', fontSize: 18 },
            },
        },
        navItem: {
            display: 'flex',
            alignItems: 'center',
            height: 48,
            cursor: 'pointer',
            flexShrink: 0,
            padding: '0 12px',
            gap: 12,
            selectors: {
                ':hover': { backgroundColor: 'rgba(255,255,255,0.15)' },
            },
        },
        navItemSelected: {
            display: 'flex',
            alignItems: 'center',
            height: 48,
            cursor: 'pointer',
            flexShrink: 0,
            padding: '0 12px',
            gap: 12,
            backgroundColor: 'white',
        },
        navIcon: {
            color: 'white',
            fontSize: 18,
            width: 24,
            textAlign: 'center' as const,
            flexShrink: 0,
        },
        navIconSelected: {
            color: 'var(--color-primario)',
            fontSize: 18,
            width: 24,
            textAlign: 'center' as const,
            flexShrink: 0,
        },
        navLabel: {
            color: 'white',
            fontSize: 13,
            whiteSpace: 'nowrap' as const,
            overflow: 'hidden',
            opacity: expanded ? 1 : 0,
            transition: 'opacity 0.15s ease',
        },
        navLabelSelected: {
            color: 'var(--color-primario)',
            fontSize: 13,
            fontWeight: 600,
            whiteSpace: 'nowrap' as const,
            overflow: 'hidden',
            opacity: expanded ? 1 : 0,
            transition: 'opacity 0.15s ease',
        },
    });

    return (
        <div className={classes.sidebar}>
            <IconButton
                className={classes.toggleBtn}
                iconProps={{ iconName: expanded ? 'Back' : 'CollapseMenu' }}
                onClick={() => setExpanded(e => !e)}
                title={expanded ? 'Colapsar' : 'Expandir'} />
            {props.menuItems.map((item: INavLink, index: number) => {
                const isSelected = location.pathname.startsWith(item.url);
                return (
                    <div
                        key={index}
                        className={isSelected ? classes.navItemSelected : classes.navItem}
                        onClick={() => navigate(item.url)}
                        title={item.title}>
                        <Icon
                            iconName={item.icon || ''}
                            className={isSelected ? classes.navIconSelected : classes.navIcon} />
                        <span className={isSelected ? classes.navLabelSelected : classes.navLabel}>
                            {item.title}
                        </span>
                    </div>
                );
            })}
        </div>
    );
};

export default NavbarLeftComponent;
